import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

const LogsView = Loadable(
  lazy(() => import('src/pages/reports/logs/LogsView'))
);

const routes = [
  {
    path: 'reporting/logs',
    element: <LogsView />
  }
];

export default routes;
